import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { MdClose, MdDelete, MdEdit, MdLocationOn, MdPersonSearch } from "react-icons/md";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import {
  ConfirmDeleteDialog,
  InfoDialog,
  Loader,
  ScrollToTop,
  SearchBar,
} from "../../../components";
import { ShowTableDaftarPermohonan, StatusChip } from "../../../components/ShowTable";

const statusOptions = [
  { label: "Semua", value: "" },
  { label: "Belum", value: "BELUM" },
  { label: "Acc", value: "ACC" },
  { label: "Reject", value: "REJECT" },
];
const spvUserTypes = ["SPV", "SPV/KOMITE", "KOMITE/SPV"];
const finalStatuses = ["ACC", "REJECT"];

const TampilDaftarPermohonan = () => {
  const { user, dispatch } = useContext(AuthContext);
  const { screenSize } = useStateContext();
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.pathname.split("/")[2];

  const [selectedEntryPermohonan, setSelectedEntryPermohonan] = useState(null);
  const [entryPermohonansData, setEntryPermohonansData] = useState([]);
  const [statusFilter, setStatusFilter] = useState("BELUM");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [limit] = useState(20);
  const [pages, setPages] = useState(0);
  const [query, setQuery] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedSurveyor, setSelectedSurveyor] = useState(null);
  const [surveyors, setSurveyors] = useState([]);
  const [openSurveyor, setOpenSurveyor] = useState(false);
  const [pageSurveyor, setPageSurveyor] = useState(0);
  const [limitSurveyor] = useState(10);
  const [pagesSurveyor, setPagesSurveyor] = useState(0);
  const [querySurveyor, setQuerySurveyor] = useState("");
  const [searchTermSurveyor, setSearchTermSurveyor] = useState("");
  const [loadingSurveyor, setLoadingSurveyor] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleteError, setDeleteError] = useState("");
  const isSpvUser = spvUserTypes.includes((user?.tipeUser || "").toUpperCase());
  const isFinalDecision = finalStatuses.includes(selectedEntryPermohonan?.status);
  const isDecisionLockedForSpv = isSpvUser && isFinalDecision;

  useEffect(() => {
    if (id) {
      getEntryPermohonanById();
    } else {
      setSelectedEntryPermohonan(null);
    }
  }, [id]);

  useEffect(() => {
    getEntryPermohonans();
  }, [page, searchTerm, statusFilter, selectedSurveyor]);

  useEffect(() => {
    if (openSurveyor) {
      getSurveyors();
    }
  }, [openSurveyor, pageSurveyor, searchTermSurveyor]);

  const handleAuthError = (err) => {
    if (err.response?.status === 401) {
      dispatch({ type: "LOGOUT" });
      navigate("/");
    }
  };

  const getEntryPermohonans = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${tempUrl}/permohonansPagination?status=${statusFilter}&surveyor_id=${selectedSurveyor?._id || ""}&search_query=${encodeURIComponent(searchTerm)}&page=${page}&limit=${limit}`,
        {
          id: user._id,
          token: user.token,
        },
      );
      setQuery(searchTerm);
      setEntryPermohonansData(response.data.permohonans);
      setPage(response.data.page);
      setPages(response.data.totalPage);
    } catch (err) {
      handleAuthError(err);
      setError(err.response?.data?.message || "Gagal mengambil daftar permohonan.");
    }
    setLoading(false);
  };

  const getEntryPermohonanById = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${tempUrl}/permohonans/${id}`, {
        id: user._id,
        token: user.token,
      });
      setSelectedEntryPermohonan(response.data);
    } catch (err) {
      handleAuthError(err);
      setError(err.response?.data?.message || "Gagal mengambil detail permohonan.");
    }
    setLoading(false);
  };

  const searchData = (event) => {
    event.preventDefault();
    setPage(0);
    setSearchTerm(query);
  };

  const changeStatusFilter = (value) => {
    setPage(0);
    setStatusFilter(value);
  };

  const getSurveyors = async () => {
    setLoadingSurveyor(true);
    try {
      const response = await axios.post(
        `${tempUrl}/surveyorsAllCabangPagination?search_query=${encodeURIComponent(searchTermSurveyor)}&page=${pageSurveyor}&limit=${limitSurveyor}`,
        {
          id: user._id,
          token: user.token,
        },
      );
      setQuerySurveyor(searchTermSurveyor);
      setSurveyors(response.data.surveyors);
      setPageSurveyor(response.data.page);
      setPagesSurveyor(response.data.totalPage);
    } catch (err) {
      handleAuthError(err);
      setError(err.response?.data?.message || "Gagal mengambil data surveyor.");
    }
    setLoadingSurveyor(false);
  };

  const searchSurveyor = (event) => {
    event.preventDefault();
    setPageSurveyor(0);
    setSearchTermSurveyor(querySurveyor);
  };

  const selectSurveyor = (surveyor) => {
    setSelectedSurveyor(surveyor);
    setPage(0);
    setOpenSurveyor(false);
  };

  const clearSurveyorFilter = () => {
    setSelectedSurveyor(null);
    setPage(0);
  };

  const deleteDaftarPermohonan = async () => {
    if (!selectedEntryPermohonan?.namaPemohonId) {
      setDeleteError("Data Daftar Permohonan tidak ditemukan.");
      return;
    }

    setShowDeleteConfirm(false);
    setLoading(true);
    try {
      await axios.post(
        `${tempUrl}/deleteNamaPemohon/${selectedEntryPermohonan.namaPemohonId}`,
        {
          id: user._id,
          token: user.token,
        },
      );
      navigate("/namaPemohon");
      await getEntryPermohonans();
    } catch (err) {
      handleAuthError(err);
      setDeleteError(err.response?.data?.message || "Gagal menghapus Daftar Permohonan.");
      setLoading(false);
    }
  };

  const getPhotoUrl = (photo) => {
    return typeof photo === "string" ? photo : photo?.url;
  };

  const formatCapturedAt = (capturedAt) => {
    if (!capturedAt) return "-";

    return new Intl.DateTimeFormat("id-ID", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }).format(new Date(capturedAt));
  };

  const getGoogleMapsUrl = (photo) => {
    return `https://www.google.com/maps?q=${photo.latitude},${photo.longitude}`;
  };

  const fotoSections = selectedEntryPermohonan
    ? [
        { title: "Foto KTP", data: selectedEntryPermohonan.fotoKtp || [] },
        { title: "KK", data: selectedEntryPermohonan.fotoKk || [] },
        { title: "Penjamin", data: selectedEntryPermohonan.fotoPenjamin || [] },
        { title: "Kendaraan Depan/Belakang", data: selectedEntryPermohonan.fotoKendaraan || [] },
        { title: "STNK & BPKB", data: selectedEntryPermohonan.fotoStnkBpkb || [] },
        { title: "Lingkungan", data: selectedEntryPermohonan.fotoLingkungan || [] },
        { title: "Lain2 Pendukung", data: selectedEntryPermohonan.fotoLainPendukung || [] },
      ]
    : [];

  const renderFotoGroup = (section) => {
    return (
      <section className="section-panel mt-3" key={section.title}>
        <h2 className="h6 fw-bold mb-3">{section.title}</h2>
        {section.data.length === 0 && <div className="text-muted">Belum ada foto.</div>}
        <div className="photo-grid">
          {section.data.map((photo, index) => (
            <div className="photo-card" key={`${section.title}-${index}`}>
              <button
                type="button"
                onClick={() => window.open(getPhotoUrl(photo), "_blank", "noopener,noreferrer")}
              >
                <img src={getPhotoUrl(photo)} alt={`${section.title} ${index + 1}`} />
                <span>No. {index + 1}</span>
              </button>
              <div className="photo-meta">
                <div>
                  <strong>Waktu</strong>
                  <span>{formatCapturedAt(photo?.capturedAt)}</span>
                </div>
              </div>
              {typeof photo !== "string" &&
                photo?.latitude != null &&
                photo?.longitude != null && (
                  <Button
                    className="photo-map-btn"
                    size="sm"
                    variant="outline-primary"
                    type="button"
                    onClick={() =>
                      window.open(getGoogleMapsUrl(photo), "_blank", "noopener,noreferrer")
                    }
                  >
                    <MdLocationOn /> Lihat Maps
                  </Button>
                )}
            </div>
          ))}
        </div>
      </section>
    );
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div>
      <ScrollToTop />
      <div className="page-header">
        <div>
          <div className="page-kicker">Survey</div>
          <h1 className="page-title">Daftar Permohonan</h1>
        </div>
      </div>
      {error && <Alert variant="warning">{error}</Alert>}

      {selectedEntryPermohonan && (
        <>
          <section className="section-panel">
            <div className="toolbar mt-0">
              <div className="detail-title-actions">
                <Button
                  className="btn-back"
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => navigate("/namaPemohon")}
                >
                  {"< Kembali"}
                </Button>
                <div>
                  <h2 className="h6 fw-bold mb-1">Detail Permohonan</h2>
                  <div className="text-muted">{selectedEntryPermohonan.namaPemohon}</div>
                </div>
              </div>
              {!isDecisionLockedForSpv && (
                <div className="d-flex gap-2 flex-wrap">
                  <Button
                    className="btn-icon"
                    size="sm"
                    variant="outline-primary"
                    onClick={() => navigate(`/namaPemohon/${id}/edit`)}
                  >
                    <MdEdit /> Ubah
                  </Button>
                  {selectedEntryPermohonan.namaPemohonId && (
                    <Button
                      className="btn-icon"
                      size="sm"
                      variant="outline-danger"
                      onClick={() => setShowDeleteConfirm(true)}
                    >
                      <MdDelete /> Hapus
                    </Button>
                  )}
                </div>
              )}
            </div>
            {isDecisionLockedForSpv && (
              <Alert variant="info" className="mt-3 mb-0">
                Data sudah {selectedEntryPermohonan.status}. SPV tidak bisa mengubah atau menghapus keputusan ini.
              </Alert>
            )}
            <hr />
            <Row>
              <Col lg={6} md={8}>
                <div className="mb-3">
                  <div className="detail-label">Nama Pemohon</div>
                  <div className="detail-value">{selectedEntryPermohonan.namaPemohon || "-"}</div>
                </div>
                <div className="mb-3">
                  <div className="detail-label">Surveyor</div>
                  <div className="detail-value">
                    {selectedEntryPermohonan.userId?.kodeSurveyor?.kodeSurveyor
                      ? `${selectedEntryPermohonan.userId.kodeSurveyor.kodeSurveyor} - ${selectedEntryPermohonan.userId.kodeSurveyor.namaSurveyor}`
                      : selectedEntryPermohonan.userId?.username || "-"}
                  </div>
                </div>
                <div className="mb-3">
                  <div className="detail-label">Status</div>
                  <div className="detail-value">{selectedEntryPermohonan.status || "BELUM"}</div>
                </div>
                <div className="mb-3">
                  <div className="detail-label">Alasan</div>
                  <div className="detail-value">{selectedEntryPermohonan.alasan || "-"}</div>
                </div>
              </Col>
            </Row>
          </section>
          {fotoSections.map(renderFotoGroup)}
        </>
      )}

      <section className="section-panel">
        <Row>
          <Col lg={6}>
            <div className="mb-3">
              <div className="detail-label mb-2">Filter Status</div>
              <div className="d-flex flex-wrap gap-3">
                {statusOptions.map((option) => (
                  <Form.Check
                    key={option.label}
                    inline
                    type="radio"
                    name="statusFilter"
                    id={`status-filter-${option.label}`}
                    label={option.label}
                    checked={statusFilter === option.value}
                    onChange={() => changeStatusFilter(option.value)}
                  />
                ))}
              </div>
            </div>
          </Col>
          <Col lg={6}>
            <Form.Group className="mb-3">
              <Form.Label className="detail-label">Filter Surveyor</Form.Label>
              <div className="filter-picker">
                <Form.Control
                  value={
                    selectedSurveyor
                      ? `${selectedSurveyor.kodeSurveyor} - ${selectedSurveyor.namaSurveyor}`
                      : ""
                  }
                  placeholder="SEMUA SURVEYOR"
                  readOnly
                  onClick={() => setOpenSurveyor(true)}
                />
                <Button
                  className="btn-icon"
                  type="button"
                  onClick={() => setOpenSurveyor(true)}
                >
                  <MdPersonSearch /> Pilih
                </Button>
                {selectedSurveyor && (
                  <Button
                    className="btn-icon"
                    type="button"
                    variant="outline-secondary"
                    onClick={clearSurveyorFilter}
                  >
                    <MdClose /> Hapus Filter
                  </Button>
                )}
              </div>
            </Form.Group>
          </Col>
        </Row>
        <Form onSubmit={searchData}>
          <div className="search-row mt-0">
            <SearchBar value={query} setSearchTerm={setQuery} />
            <Button type="submit">Cari</Button>
          </div>
        </Form>
      </section>

      <div className="status-legend">
        <span className="status-legend-title">Keterangan Status</span>
        <div className="status-legend-items">
          <StatusChip statusValue="BELUM" />
          <StatusChip statusValue="ACC" />
          <StatusChip statusValue="REJECT" />
        </div>
      </div>
      <ShowTableDaftarPermohonan currentPosts={entryPermohonansData} />
      <div className="search-row">
        <Pagination
          count={pages}
          page={page + 1}
          onChange={(event, selectedPage) => setPage(selectedPage - 1)}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </div>
      <Dialog
        open={openSurveyor}
        onClose={() => setOpenSurveyor(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Pilih Surveyor</DialogTitle>
        <DialogContent>
          <Form onSubmit={searchSurveyor}>
            <div className="search-row mt-0 mb-3">
              <Form.Control
                value={querySurveyor}
                placeholder="Cari kode atau nama surveyor..."
                onChange={(event) => setQuerySurveyor(event.target.value)}
              />
              <Button type="submit">Cari</Button>
            </div>
          </Form>
          <TableContainer component={Paper}>
            <Table aria-label="pilih surveyor">
              <TableHead>
                <TableRow>
                  <TableCell>Kode Surveyor</TableCell>
                  <TableCell>Nama Surveyor</TableCell>
                  <TableCell>Jenis</TableCell>
                  <TableCell>Telepon</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {!loadingSurveyor &&
                  surveyors.map((surveyor) => (
                    <TableRow
                      key={surveyor._id}
                      className="row-clickable"
                      onClick={() => selectSurveyor(surveyor)}
                    >
                      <TableCell>{surveyor.kodeSurveyor || "-"}</TableCell>
                      <TableCell>{surveyor.namaSurveyor || "-"}</TableCell>
                      <TableCell>{surveyor.jenisSurveyor || "-"}</TableCell>
                      <TableCell>{surveyor.teleponSurveyor || "-"}</TableCell>
                    </TableRow>
                  ))}
                {!loadingSurveyor && surveyors.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      Data Surveyor tidak ditemukan.
                    </TableCell>
                  </TableRow>
                )}
                {loadingSurveyor && (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      Memuat data...
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <div className="search-row">
            <Pagination
              count={pagesSurveyor}
              page={pageSurveyor + 1}
              onChange={(event, selectedPage) =>
                setPageSurveyor(selectedPage - 1)
              }
              color="primary"
              size={screenSize <= 600 ? "small" : "medium"}
            />
          </div>
        </DialogContent>
        <DialogActions>
          {selectedSurveyor && (
            <Button
              variant="outline-secondary"
              type="button"
              onClick={() => {
                clearSurveyorFilter();
                setOpenSurveyor(false);
              }}
            >
              <MdClose /> Semua Surveyor
            </Button>
          )}
          <Button
            className="btn-back"
            variant="outline-secondary"
            type="button"
            onClick={() => setOpenSurveyor(false)}
          >
            {"< Kembali"}
          </Button>
        </DialogActions>
      </Dialog>
      <ConfirmDeleteDialog
        show={showDeleteConfirm}
        message={`Yakin ingin menghapus Daftar Permohonan ${selectedEntryPermohonan?.namaPemohon}? Status Entry Permohonan akan kembali menjadi BELUM.`}
        onCancel={() => setShowDeleteConfirm(false)}
        onConfirm={deleteDaftarPermohonan}
      />
      <InfoDialog
        show={Boolean(deleteError)}
        title="Data Tidak Bisa Dihapus"
        message={deleteError}
        onClose={() => setDeleteError("")}
      />
    </div>
  );
};

export default TampilDaftarPermohonan;
